import { Navigate, Outlet } from 'react-router';
import { FullPageSpinner } from '../../components/FullPageSpinner';
import { FirmaCurentaProvider } from '../firme/FirmaCurentaContext';
import { useSession } from './useSession';

/**
 * Layout route guarding everything under `/` (the whole app shell). Renders
 * the authenticated subtree — wrapped in FirmaCurentaProvider, since "which
 * firm" only makes sense once we know who's logged in — or bounces to
 * /login when the boot `/auth/me` check comes back 401.
 */
export function AuthGuard() {
  const { data: user, isLoading, isError } = useSession();

  if (isLoading) {
    return <FullPageSpinner />;
  }

  if (isError || !user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <FirmaCurentaProvider>
      <Outlet />
    </FirmaCurentaProvider>
  );
}
